import { defineComponent as _defineComponent } from 'vue'
import BaseChip from "@/components-UI/BaseChip.vue";
import { computed } from "vue";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";

interface Props {
    chips: string[],
    maxChips?: number,
    tooltipWidth?: string,
    isDeletable?: boolean,
    isTeleportChipTooltip?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseChipCollection',
  props: {
    chips: null,
    maxChips: { default: 3 },
    tooltipWidth: { default: '300px' },
    isDeletable: { type: Boolean },
    isTeleportChipTooltip: { type: Boolean }
  },
  emits: ['delete'],
  setup(__props: any, { emit: emits }) {

const props = __props as { chips: string[], maxChips: number, tooltipWidth: string, isDeletable?: boolean, isTeleportChipTooltip?: boolean }





const getChips = computed(() => {
    return props.chips.length > props.maxChips ? props.chips.slice(0, props.maxChips) : props.chips;
});

const getTooltipText = computed(() => {
    return props.chips.slice(props.maxChips).join(', ');
});

const handleDeleteChip = (chip: string, index: number) => {
    emits('delete', { item: chip, index });
};

return { __sfc: true,props, emits, getChips, getTooltipText, handleDeleteChip, BaseChip, BaseTooltip }
}

})